import * as THREE from 'three';
import { LineSegments } from 'three';
export class Voxel extends THREE.Object3D {
    constructor() {
        super();
        this._state = Voxel.State.Empty;
        this.state = this._state;
    }
    get state() {
        return this._state;
    }
    set state(value) {
        this._state = value;
        this.clear();
        var child;
        switch (value) {
            case Voxel.State.Filled:
                child = new THREE.Mesh(new THREE.BoxGeometry(), Voxel.matFilled);
                this.visible = true;
                break;
            case Voxel.State.Valid:
                child = new LineSegments(Voxel.spaceGeometry, Voxel.matValid);
                this.visible = true;
                break;
            default:
                child = new LineSegments(Voxel.spaceGeometry, Voxel.matEmptySpace);
                this.visible = false;
                break;
        }
        child.position.y = 0.5;
        this.add(child);
    }
}
Voxel.boxGeometry = new LineSegments(new THREE.EdgesGeometry(new THREE.BoxGeometry()));
Voxel.spaceGeometry = new THREE.EdgesGeometry(new THREE.BoxGeometry());
Voxel.matEmptySpace = new THREE.LineBasicMaterial({ color: 0x333333 });
Voxel.matFilled = new THREE.MeshLambertMaterial({ color: 0xff6600 });
Voxel.matValid = new THREE.LineBasicMaterial({ color: 0xaa6600 });
(function (Voxel) {
    let State;
    (function (State) {
        State[State["Empty"] = 0] = "Empty";
        State[State["Filled"] = 1] = "Filled";
        State[State["Valid"] = 2] = "Valid";
    })(State = Voxel.State || (Voxel.State = {}));
})(Voxel || (Voxel = {}));
